import { MapPin, PlayCircle } from "lucide-react";
import Reveal from "@/components/landing/Reveal";
import { renderTitle, toFullUrl } from "@/components/landing/utils";

export default function CaseStudiesSection({ block }) {
  const items = block?.items || [];
  return (
    <section className="section-onyx on-onyx py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <Reveal><span className="eyebrow">Casos de éxito</span></Reveal>
          <Reveal delay={120}>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl text-[#0A0A0A]">
              {renderTitle(block?.title || "Un proyecto ya recorrido y sucursales <em>operando</em>.")}
            </h2>
          </Reveal>
          {block?.subtitle && (
            <Reveal delay={220}>
              <p className="mt-5 text-[#3F3F46] text-base leading-relaxed">{block.subtitle}</p>
            </Reveal>
          )}
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {items.map((c, i) => {
            const img = toFullUrl(c.image_url);
            const video = toFullUrl(c.video_url);
            return (
              <Reveal key={i} delay={i * 120}>
                <div className="glass overflow-hidden h-full group" data-testid={`case-${i}`}>
                  <div className="aspect-[9/16] bg-[#E4E4E7] relative overflow-hidden">
                    {video ? (
                      <video
                        src={video}
                        poster={img}
                        muted
                        loop
                        playsInline
                        autoPlay
                        className="w-full h-full object-cover"
                      />
                    ) : img ? (
                      <img loading="lazy" decoding="async" src={img} alt={c.title} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-[#0F0F13] to-[#1A1A22] flex items-center justify-center">
                        <PlayCircle size={48} className="text-[#0A0A0A]/40" />
                      </div>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      {c.metric && (
                        <div className="inline-block pill pill-gold mb-3">{c.metric}</div>
                      )}
                      <div className="font-display text-xl text-[#0A0A0A]">{c.title}</div>
                      <div className="text-[11px] text-[#3F3F46] mt-0.5 flex items-center gap-1.5"><MapPin size={10} /> {c.city}</div>
                    </div>
                    {c.tag && (
                      <div className="absolute top-3 left-3 pill !bg-black/60 !backdrop-blur-md text-[9px]">
                        {c.tag}
                      </div>
                    )}
                  </div>
                  {c.body && (
                    <div className="p-5">
                      <p className="text-sm text-[#3F3F46] leading-relaxed">{c.body}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
